export const DEFAULT_RESTAURANT_EXEMPLE_PROPS = {
  announcement:
    'Une cuisine vivante, au rythme des saisons · Fait maison avec amour',
  brandLine1: 'la table',
  brandLine2: 'des jardins',
  heroImage:
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=2200&q=90',
  heroEyebrow: 'LE GOÛT DES BELLES CHOSES',
  heroTitleHtml: 'La nature<br>à <em>votre table.</em>',
  heroCopy:
    'Une cuisine de saison, sincère et créative.<br>Un lieu où l’on prend le temps de savourer.',
  introImage:
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1000&q=85',
  introEyebrow: 'BIENVENUE CHEZ NOUS',
  introTitleHtml: 'Le bonheur tient<br>parfois à <em>une bouchée.</em>',
  introBody:
    'À La Table des Jardins, nous croyons aux choses simples, aux saisons qui inspirent et aux repas qui rapprochent. Des produits soigneusement choisis, une cuisine généreuse et une hospitalité qui fait du bien.',
  seasonalImage:
    'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1400&q=85',
  seasonalEyebrow: 'AU FIL DES SAISONS',
  seasonalTitleHtml: 'Des produits<br>vrais. Des saveurs<br><em>qui restent.</em>',
  seasonalText:
    "Une carte courte, pensée au gré du marché, des récoltes et de l'inspiration du chef. Parce que le meilleur ingrédient, c'est celui qui est à son apogée.",
  seasonalTags: '✳ Produits de saison|✳ Fait maison|✳ Plaisir partagé',
  menuEyebrow: "L'INSPIRATION DU MOMENT",
  menuTitleHtml: 'Une carte qui suit<br><em>la nature.</em>',
  menuNote:
    'Chaque saison écrit un nouveau chapitre.<br>Voici un aperçu de notre univers culinaire.',
  menuDisclaimer:
    "Suggestions d'ambiance — la carte et les prix définitifs sont à personnaliser par le restaurant.",
  dishCards: [
    {
      metaLeft: '01 — POUR COMMENCER',
      metaRight: 'À découvrir',
      title: 'Le jardin en entrée',
      description: 'Légumes du moment, herbes fraîches et vinaigrette maison.',
      image:
        'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=800&q=85',
      offset: false,
    },
    {
      metaLeft: '02 — LE CŒUR DU REPAS',
      metaRight: 'À découvrir',
      title: 'La belle saison',
      description: 'Une assiette généreuse, des produits choisis et une touche créative.',
      image:
        'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=800&q=85',
      offset: true,
    },
    {
      metaLeft: '03 — LA NOTE DOUCE',
      metaRight: 'À découvrir',
      title: 'Un peu de douceur',
      description: 'Un dessert maison, gourmand et délicatement équilibré.',
      image:
        'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&w=800&q=85',
      offset: false,
    },
  ],
  quoteHtml: 'Le meilleur souvenir d’un repas,<br>c’est souvent l’envie d’y revenir.',
  quoteBy: 'LA TABLE DES JARDINS',
  galleryImages: [
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1000&q=85',
    'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1000&q=85',
    'https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1000&q=85',
  ],
  galleryEyebrow: 'UN LIEU À PARTAGER',
  galleryTitleHtml: 'Installez-vous.<br><em>Vous êtes chez vous.</em>',
  galleryNote:
    'Un cadre chaleureux, une atmosphère apaisée<br>et de belles raisons de rester un peu.',
  reservationEyebrow: 'VOTRE PROCHAINE BELLE TABLE',
  reservationTitleHtml: 'On vous<br>garde une <em>place ?</em>',
  reservationLead: 'Choisissez votre moment, nous nous occupons du reste.',
  reservationNoteTitle: 'Une occasion spéciale ?',
  reservationNoteText:
    'Anniversaire, dîner à deux ou déjeuner entre amis : dites-le-nous dans votre demande.',
  bookingKicker: 'RÉSERVATION EN LIGNE',
  bookingTitle: 'Votre table, en quelques clics.',
  practicalEyebrow: 'PASSONS À TABLE',
  practicalTitleHtml: 'On se retrouve<br><em>très bientôt.</em>',
  addressHtml: 'Adresse du restaurant<br>Code Postal · Ville',
  hoursHtml: 'Mar. — Dim.<br>12h00–14h00 · 19h00–22h00',
  contactHtml: '+33 (0)1 00 00 00 00<br>bonjour@latabledesjardins.fr',
  contactEmail: 'bonjour@latabledesjardins.fr',
  footerTagline: 'Une cuisine sincère. Des moments précieux.',
  menuCartLabel: 'La carte',
  menuCartPath: 'commande',
  heroDiscoverLabel: 'Découvrir la carte',
  galleryImageAlts: [
    'Table dressée dans un restaurant',
    'Intérieur chaleureux de restaurant',
    'Moment convivial autour d’un repas',
  ],
};

export const RESTAURANT_SECTION_VARIANT_ORDER = [
  'chrome',
  'hero',
  'intro',
  'seasonal',
  'dishes',
  'quote',
  'gallery',
  'reservation',
  'practical',
  'footer',
];

export const RESTAURANT_SECTION_VARIANT_LABELS = {
  chrome: 'Bandeau & navigation',
  hero: 'Accueil (hero)',
  intro: 'Notre esprit',
  seasonal: 'Au fil des saisons',
  dishes: 'Plats & inspiration',
  quote: 'Citation',
  gallery: 'Galerie',
  reservation: 'Réservation',
  practical: 'Infos pratiques',
  footer: 'Pied de page',
};

export const RESTAURANT_VARIANT_ROW_SPAN = {
  chrome: 5,
  hero: 14,
  intro: 12,
  seasonal: 10,
  dishes: 14,
  quote: 6,
  gallery: 10,
  reservation: 14,
  practical: 8,
  footer: 5,
};

const VARIANT_PROP_KEYS = {
  chrome: ['announcement', 'brandLine1', 'brandLine2', 'menuCartLabel'],
  hero: ['heroImage', 'heroEyebrow', 'heroTitleHtml', 'heroCopy', 'heroDiscoverLabel'],
  intro: ['introImage', 'introEyebrow', 'introTitleHtml', 'introBody'],
  seasonal: ['seasonalImage', 'seasonalEyebrow', 'seasonalTitleHtml', 'seasonalText', 'seasonalTags'],
  dishes: ['menuEyebrow', 'menuTitleHtml', 'menuNote', 'menuDisclaimer', 'dishCards'],
  quote: ['quoteHtml', 'quoteBy'],
  gallery: ['galleryEyebrow', 'galleryTitleHtml', 'galleryNote', 'galleryImages', 'galleryImageAlts'],
  reservation: [
    'reservationEyebrow',
    'reservationTitleHtml',
    'reservationLead',
    'reservationNoteTitle',
    'reservationNoteText',
    'bookingKicker',
    'bookingTitle',
  ],
  practical: [
    'practicalEyebrow',
    'practicalTitleHtml',
    'addressHtml',
    'hoursHtml',
    'contactHtml',
    'contactEmail',
  ],
  footer: ['footerTagline', 'brandLine1', 'brandLine2'],
};

export function propsForRestaurantVariant(variant, source = {}) {
  const keys = VARIANT_PROP_KEYS[variant] || [];
  const out = { variant };
  for (const key of keys) {
    if (source[key] !== undefined) out[key] = source[key];
  }
  return out;
}

export function defaultPropsForRestaurantVariant(variant) {
  return {
    paddingX: 0,
    paddingY: 0,
    variant,
    ...propsForRestaurantVariant(variant, DEFAULT_RESTAURANT_EXEMPLE_PROPS),
  };
}

export function mergeRestaurantExempleProps(props) {
  const p = props && typeof props === 'object' ? props : {};
  const dishCards =
    Array.isArray(p.dishCards) && p.dishCards.length
      ? p.dishCards
      : DEFAULT_RESTAURANT_EXEMPLE_PROPS.dishCards;
  const galleryImages =
    Array.isArray(p.galleryImages) && p.galleryImages.length
      ? p.galleryImages
      : DEFAULT_RESTAURANT_EXEMPLE_PROPS.galleryImages;
  const galleryImageAlts =
    Array.isArray(p.galleryImageAlts) && p.galleryImageAlts.length
      ? p.galleryImageAlts
      : DEFAULT_RESTAURANT_EXEMPLE_PROPS.galleryImageAlts;
  return {
    ...DEFAULT_RESTAURANT_EXEMPLE_PROPS,
    ...p,
    dishCards,
    galleryImages,
    galleryImageAlts,
  };
}

export function collectRestaurantSectionComponents(site) {
  const list = [];
  if (!site?.sections) return list;
  for (const sec of site.sections) {
    for (const comp of sec.components || []) {
      if (comp.type === 'restaurantSection') list.push(comp);
    }
  }
  return list.sort((a, b) => {
    const ai = RESTAURANT_SECTION_VARIANT_ORDER.indexOf(a.props?.variant);
    const bi = RESTAURANT_SECTION_VARIANT_ORDER.indexOf(b.props?.variant);
    if (ai !== bi) return ai - bi;
    return (a.row ?? 0) - (b.row ?? 0);
  });
}

export function siteHasRestaurantLanding(site) {
  if (!site?.sections) return false;
  for (const sec of site.sections) {
    for (const comp of sec.components || []) {
      if (comp.type === 'restaurantPage' || comp.type === 'restaurantSection') return true;
    }
  }
  return false;
}

export function mergeRestaurantSiteProps(site) {
  if (!site?.sections) return null;
  let legacy = null;
  const merged = {};
  for (const sec of site.sections) {
    for (const comp of sec.components || []) {
      if (comp.type === 'restaurantPage') legacy = comp.props;
      if (comp.type === 'restaurantSection' && comp.props) {
        Object.assign(merged, comp.props);
      }
    }
  }
  if (legacy) Object.assign(merged, legacy);
  if (!legacy && !Object.keys(merged).length) return null;
  return mergeRestaurantExempleProps(merged);
}

export function getRestaurantPageComponent(site) {
  if (!site?.sections) return null;
  for (const sec of site.sections) {
    const comp = (sec.components || []).find((c) => c.type === 'restaurantPage');
    if (comp) return comp;
  }
  const merged = mergeRestaurantSiteProps(site);
  if (!merged) return null;
  return {
    id: 'restaurant-landing-merged',
    type: 'restaurantPage',
    props: merged,
  };
}

export function splitRestaurantPageInSection(section) {
  const idx = (section.components || []).findIndex((c) => c.type === 'restaurantPage');
  if (idx === -1) return section;
  const page = section.components[idx];
  const source = page.props || {};
  let row = 0;
  const newComponents = RESTAURANT_SECTION_VARIANT_ORDER.map((variant, layoutIndex) => {
    const rowSpan = RESTAURANT_VARIANT_ROW_SPAN[variant] || 8;
    const comp = {
      id: `${page.id}-${variant}`,
      type: 'restaurantSection',
      colStart: page.colStart ?? 1,
      colSpan: page.colSpan ?? 48,
      row,
      rowSpan,
      layout: layoutIndex + 1,
      props: defaultPropsForRestaurantVariant(variant),
    };
    Object.assign(comp.props, propsForRestaurantVariant(variant, source));
    row += rowSpan;
    return comp;
  });
  const others = section.components.filter((c) => c.type !== 'restaurantPage');
  return {
    ...section,
    gridRows: row,
    gridRowsCustom: true,
    paddingY: 0,
    components: [...newComponents, ...others],
  };
}

export function migrateRestaurantSiteSections(site) {
  if (!site?.sections) return site;
  if (site.sections.some((sec) => sec.designKit === 'jardins')) return site;
  let changed = false;
  const sections = site.sections.map((sec) => {
    const hasPage = (sec.components || []).some((c) => c.type === 'restaurantPage');
    const hasBlocks = (sec.components || []).some((c) => c.type === 'restaurantSection');
    if (!hasPage || hasBlocks) return sec;
    changed = true;
    return splitRestaurantPageInSection(sec);
  });
  return changed ? { ...site, sections } : site;
}
